import { Icon, Modal, Text } from 'components'

import styles from './styles.module.scss'
import { useNavigate } from 'react-router-dom'

const GoBack = () => {
  const navigate = useNavigate()

  return (
    <Modal.Content className={styles.container}>
      <div className={styles.content}>
        <Icon width={48} color="element-default" name="warning" />

        <Modal.Title className={styles.title}>
          Voltar para tela anterior?
        </Modal.Title>

        <Text as="p" weight="regular">
          Todas as informações preenchidas serão perdidas.
        </Text>
      </div>

      <Modal.Footer className={styles.footer}>
        <div className={styles.actions}>
          <Modal.Close asChild>
            <button>Cancelar</button>
          </Modal.Close>
          <button onClick={() => navigate(-1)}>Confirmar</button>
        </div>
      </Modal.Footer>
    </Modal.Content>
  )
}

export default GoBack
